import { Component, Input, inject } from "@angular/core";
import {IonicModule} from "@ionic/angular";
import {AsyncPipe} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";
import {AttachmentTypes} from "@server-models";
import {SharedAttachmentsService} from "@shared/components/attachments/services/shared-attachments.service";
import {ILocalAttachmentDto} from "@shared/components/attachments/interfaces/orga-attachment-dto-extend.interface";

@Component({
  selector: 'app-shared-attachments-box-item',
  templateUrl: './shared-attachments-box-item.component.html',
  styleUrls: ['./shared-attachments-box-item.component.scss'],
  imports: [
    IonicModule,
    AsyncPipe
],
  standalone: true
})
export class SharedAttachmentsBoxComponent {
  attachmentsService = inject(SharedAttachmentsService);
  private _translateService = inject(TranslateService);

  @Input() mappedAttachments: ILocalAttachmentDto[];
  @Input() lines: string = 'none';

  attachmentType: typeof AttachmentTypes = AttachmentTypes;

  constructor() {
    this.mappedAttachments = [];
  }

  /**
   * @name getAttachmentByType
   * @description
   * return the label or icon related to AttachtmentType
   * @memberof SharedAttachmentsBoxComponent
   * @param attachmentType
   */
  getAttachmentByType(attachmentType: AttachmentTypes): { label: string, icon: string } {
    let valueByType;
    switch (attachmentType) {
      case AttachmentTypes.File: {
        valueByType = {
          label: this._translateService.instant('COMPONENTS.ATTACHMENTS.FILES.TYPES.FILE'),
          icon: 'document-attach-outline'
        }
      }
        break;
      case AttachmentTypes.Knowledge: {
        valueByType = {
          label: this._translateService.instant('COMPONENTS.ATTACHMENTS.FILES.TYPES.KNOWLEDGE'),
          icon: 'library-outline'
        }
      }
        break;
      case AttachmentTypes.Link: {
        valueByType = {
          label: this._translateService.instant('COMPONENTS.ATTACHMENTS.FILES.TYPES.LINK'),
          icon: 'link-outline'
        }
      }
        break;
      default: {
        valueByType = {
          label: this._translateService.instant('COMPONENTS.ATTACHMENTS.FILES.TYPES.FILE'),
          icon: 'document-attach-outline'
        }
      }
    }

    return valueByType;
  }

}
